<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <b-card-code>
                <validation-observer ref="simpleRules">
                  <form @submit.prevent="submitForm">
                    <b-row>
                      <b-col md="6">
                        <b-form-group>
                          <label>Select Date</label>
                          <flat-pickr
                            class="form-control"
                            value=""
                            placeholder="Select Date"
                            :config="{
                              dateFormat: 'd/m/Y',
                              mode: 'range',
                              maxDate: new Date(),
                            }"
                            style="background-color: transparent"
                            @input="getdata($event)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                      <b-button
                        variant="primary"
                        class="ml-2"
                        @click="searchData"
                      >
                        <feather-icon icon="SearchIcon" class="mr-50" />
                        <span class="align-middle">Search</span>
                      </b-button>
                    </div>
                  </form>
                </validation-observer>
                <b-row>
                  <b-col md="6" class="mt-2">
                    <div style="width: 100%; overflow: auto">
                      <table
                        class="table"
                        style="min-width: 11cm; color: black"
                      >
                        <thead class="text">
                          <tr>
                            <th scope="col" class="w-1"></th>
                            <th scope="col" class="w-10">Ledger</th>
                            <th scope="col" class="w-3" style="width: 100px">
                              <p style="text-align: end">AMOUNT</p>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            @click="handelclickexpense(incomeData.name)"
                            class="cursor-pointer"
                          >
                            <td>
                              <feather-icon
                                v-if="showHideData[incomeData.name]"
                                size="17"
                                icon="MinusIcon"
                              />

                              <feather-icon v-else size="17" icon="PlusIcon" />
                            </td>
                            <td>Income</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td
                              v-if="showHideData[incomeData.name]"
                              style="padding: 0"
                              colspan="4"
                            >
                              <table class="table" style="color: black">
                                <tbody
                                  v-for="item in incomeData.data"
                                  :key="item.id"
                                >
                                  <tr
                                    @click="handelclickexpense(item.id)"
                                    class="cursor-pointer"
                                  >
                                    <td style="width: 2cm; padding-left: 35px">
                                      <feather-icon
                                        v-if="
                                          showHideData[item.id] &&
                                          item.children &&
                                          item.children.length > 0
                                        "
                                        icon="MinusIcon"
                                      />
                                      <feather-icon
                                        v-else-if="
                                          item.children &&
                                          item.children.length > 0
                                        "
                                        icon="PlusIcon"
                                      />
                                    </td>
                                    <td class="w-10">
                                      {{ item && item.name }}
                                    </td>
                                    <td
                                      class="w-3"
                                      style="text-align: end; width: 100px"
                                    >
                                      {{ item.amount }}
                                    </td>
                                  </tr>

                                  <!-- <tr @click="handelclickexpense(item.id)">
                                    <td style="padding-left: 35px" class="w-1">
                                      <span
                                        v-if="
                                          showHideData[item.id] &&
                                          item.totalamount !== 0
                                        "
                                        class="icon icon-minus"
                                      ></span>
                                      <span
                                        v-else-if="item.totalamount !== 0"
                                        class="icon icon-plus"
                                      ></span>
                                    </td>
                                    <td class="w-10">
                                      {{ item && item.code }} &#8226;
                                      {{ item && item.name }}
                                    </td>
                                    <td class="w-3 text-right">
                                      {{ item.amount }}
                                    </td>
                                  </tr> -->
                                  <children
                                    v-if="
                                      item.children && showHideData[item.id]
                                    "
                                    :item="item"
                                  />
                                  <tr v-if="item.totalamount">
                                    <td></td>
                                    <td class="font-weight-bold">
                                      {{ "Total " + item.name }}
                                    </td>
                                    <td
                                      class="text-right"
                                      style="
                                        text-align: right;
                                        font-weight: bold;
                                      "
                                    >
                                      {{ item.totalamount }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 2cm; padding-left: 25px"></td>
                            <td class="font-weight-bold">Total Income</td>
                            <td style="text-align: end; width: 100px">
                              {{ incomeData.totalamount }}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- <table
                        class="table table-bordered"
                        id="printTable"
                        style="color: black"
                        border="1"
                      >
                        <thead class="text">
                          <tr>
                            <th>Ledger</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in data"
                            :key="item.id"
                            @click="handleExpand(index, item)"
                          >
                            <td>
                              {{
                                item.type == "ledger" || item.type == "accgroup"
                                  ? "&emsp;&emsp;"
                                  : ""
                              }}
                              <feather-icon
                                v-if="item.plus"
                                size="17"
                                :icon="
                                  expanded[item.id] &&
                                  expanded[item.id][0] == true
                                    ? 'MinusIcon'
                                    : 'PlusIcon'
                                "
                              />
                              {{ item.name }}
                            </td>
                            <td>{{ item.amount }}</td>
                          </tr>
                        </tbody>
                      </table> -->
                    </div>
                  </b-col>
                  <b-col md="6" class="mt-2">
                    <div style="width: 100%; overflow: auto">
                      <table
                        class="table"
                        style="min-width: 11cm; color: black"
                      >
                        <thead class="text">
                          <tr>
                            <th scope="col" class="w-1"></th>
                            <th scope="col" class="w-10">Ledger</th>
                            <th scope="col" class="w-3" style="width: 100px">
                              <p style="text-align: end">AMOUNT</p>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            @click="handelclickexpense(cogs.name)"
                            class="cursor-pointer"
                          >
                            <td>
                              <feather-icon
                                v-if="showHideData[cogs.name]"
                                size="17"
                                icon="MinusIcon"
                              />

                              <feather-icon v-else size="17" icon="PlusIcon" />
                            </td>
                            <td>Cost of Goods Sold</td>
                            <td  style="text-align: end; width: 100px">{{ cogs.totalamount }}</td>
                          </tr>
                          <tr>
                            <td
                              v-if="showHideData[cogs.name]"
                              style="padding: 0"
                              colspan="4"
                            >
                              <table class="table" style="color: black">
                                <tbody
                                  v-for="item in cogsData.data"
                                  :key="item.id"
                                >
                                  <tr
                                    @click="handelclickexpense(item.id)"
                                    class="cursor-pointer"
                                  >
                                    <td style="width: 2cm; padding-left: 35px">
                                      <feather-icon
                                        v-if="
                                          showHideData[item.id] &&
                                          item.children &&
                                          item.children.length > 0
                                        "
                                        icon="MinusIcon"
                                      />
                                      <feather-icon
                                        v-else-if="
                                          item.children &&
                                          item.children.length > 0
                                        "
                                        icon="PlusIcon"
                                      />
                                    </td>
                                    <td class="w-10">
                                      {{ item && item.name }}
                                    </td>
                                    <td
                                      class="w-3"
                                      style="text-align: end; width: 100px"
                                    >
                                      {{ item.amount }}
                                    </td>
                                  </tr>
                                  <children
                                    v-if="
                                      item.children && showHideData[item.id]
                                    "
                                    :item="item"
                                  />
                                  <tr v-if="item.totalamount">
                                    <td></td>
                                    <td class="font-weight-bold">
                                      {{ "Total " + item.name }}
                                    </td>
                                    <td
                                      class="text-right"
                                      style="
                                        text-align: right;
                                        font-weight: bold;
                                      "
                                    >
                                      {{ item.totalamount }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 2cm; padding-left: 25px"></td>
                            <td class="font-weight-bold">Total Cost of Goods Sold</td>
                            <td style="text-align: end; width: 100px">
                              {{ cogsData.totalamount }}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                     <div style="width: 100%; overflow: auto">
                        <table
                          class="table"
                          style="min-width: 11cm; color: black"
                        >

                          <tbody>
                            <tr
                              @click="handelclickexpense(expenseData.name)"
                              class="cursor-pointer"
                            >
                              <td>
                                <feather-icon
                                  v-if="showHideData[expenseData.name]"
                                  size="17"
                                  icon="MinusIcon"
                                />

                                <feather-icon v-else size="17" icon="PlusIcon" />
                              </td>
                              <td>Expense</td>
                              <td>{{ expenseData.amount }}</td>
                            </tr>
                            <tr>
                              <td
                                v-if="showHideData[expenseData.name]"
                                style="padding: 0"
                                colspan="4"
                              >
                                <table class="table" style="color: black">
                                  <tbody
                                    v-for="item in expenseData.data"
                                    :key="item.id"
                                  >
                                    <tr
                                      @click="handelclickexpense(item.id)"
                                      class="cursor-pointer"
                                    >
                                      <td style="width: 2cm; padding-left: 35px">
                                        <feather-icon
                                          v-if="showHideData[item.id] &&
                                            item.children &&
                                            item.children.length > 0
                                            "
                                          icon="MinusIcon"
                                        />
                                        <feather-icon
                                          v-else-if="item.children &&
                                            item.children.length > 0
                                            "
                                          icon="PlusIcon"
                                        />
                                      </td>
                                      <td class="w-10">
                                        {{ item && item.name }}
                                      </td>
                                      <td
                                        class="w-3"
                                        style="text-align: end; width: 100px"
                                      >
                                        {{ item.amount }}
                                      </td>
                                    </tr>
                                    <children
                                      v-if="item.children && showHideData[item.id]
                                        "
                                      :item="item"
                                    />
                                    <tr v-if="item.totalamount">
                                      <td></td>
                                      <td class="font-weight-bold">
                                        {{ "Total " + item.name }}
                                      </td>
                                      <td
                                        class="text-right"
                                        style="
                                        text-align: right;
                                        font-weight: bold;
                                      "
                                      >
                                        {{ item.totalamount }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 2cm; padding-left: 25px"></td>
                              <td class="font-weight-bold">Total Expanse</td>
                              <td style="text-align: end; width: 100px">
                                {{ expenseData.totalamount }}
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 2cm; padding-left: 25px"></td>
                              <td class="font-weight-bold">Net Profit</td>
                              <td style="text-align: end; width: 100px">
                                {{ expenseData.netProfit }}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </div>
                  </b-col>
                </b-row>
              </b-card-code>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/components/axios";
import BCardCode from "@core/components/b-card-code";
import flatPickr from "vue-flatpickr-component";
import ReportTable from "../../../components/ReportTable.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import children from "./balancesheetChild.vue";

import moment from "moment";
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
} from "bootstrap-vue";
const baseApi = process.env.VUE_APP_APIENDPOINT;
export default {
  components: {
    children,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BCardCode,
    ReportTable,
  },
  data() {
    return {
      incomeExpenseData: "",
      startdate: "",
      enddate: "",
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem("accessToken"),
      data1: [],
      fields: [
        { field: "ledger", label: "Ledger" },
        { field: "amount", label: "Amount" },
      ],
      expanded: {},
      ledgerExpanded: {},
      expenseObj: {},
      incomeObj: {},
      expense: [],
      income: [],
      cogs: [],
      dublicateData: [],

      showHideData: {},
      expenseData: [],
      cogsData: [],
      incomeData: [],
      cogsTemp:[]
    };
  },
  methods: {
    // handleExpand(index, clickData) {
    //   if (
    //     this.expanded[this.data[index].id] &&
    //     this.expanded[this.data[index].id][0] == true
    //   ) {
    //     this.dublicateData = this.data;
    //     this.dublicateData.push({});
    //     for (let i = index + 1; i <= this.data.length; i++) {
    //       if (
    //         this.data[index + 1].id !== this.expanded[this.data[index].id][1]
    //       ) {
    //         this.dublicateData.splice(index + 1, 1);
    //       } else {
    //         break;
    //       }
    //     }
    //     this.dublicateData.pop();
    //     this.data = this.dublicateData;

    //     this.expanded[this.data[index].id][0] = false;
    //     this.expanded[this.data[index].id][1] = "";
    //   } else {
    //     this.expanded[this.data[index].id] = [];
    //     this.expanded[this.data[index].id][0] = true;

    //     this.expanded[this.data[index].id][1] = this.data[index + 1]
    //       ? this.data[index + 1].id
    //       : 0;
    //     let last = index;

    //     this.data[index].groups &&
    //       this.data[index].groups.map((item, innerIndex) => {
    //         item.plus =
    //           item.groups.length > 0 || item.ledgers.length > 0 ? true : false;
    //         this.data.splice(index + innerIndex + 1, 0, item);
    //         this.data[index + innerIndex + 1].type = "accgroup";
    //         last = index + innerIndex + 1;
    //       });

    //     this.data[index].ledgers &&
    //       this.data[index].ledgers.map((item, innerIndex) => {
    //         this.data.splice(last + innerIndex + 1, 0, item);
    //         this.data[last + innerIndex + 1].type = "ledger";
    //       });
    //   }
    // },

    handelclickexpense(id) {
      this.showHideData[id] =
        this.showHideData[id] == undefined ? false : this.showHideData[id];
      this.showHideData[id] = this.showHideData[id] == true ? false : true;
      this.$forceUpdate();
    },

    getdata(selectedDates) {
      this.result = selectedDates.split(" to ");
      this.startdate = this.result[0];
      this.enddate = this.result[1];
    },
    recorsionFun(ele, name) {
      let children1 = [];
      let childrens = (ele.groups ? ele.groups : []).concat(
        ele.ledgers ? ele.ledgers : []
      );
      var amount = {
        totalamount: 0,
      };
      childrens.map((item, index) => {
        let tempData = {};
        tempData = this.recorsionFun(item, name);
        item = tempData;
        if (item.ledgers) {
        } else {
          amount.totalamount += parseFloat(item.amount * -1);
        }
        children1[index] = item;
      });
      let totalamountData;
      if (children1.length > 0) {
        totalamountData = this.sumTotal(children1, "amount");
      }
      ele = {
        id: ele.id,
        code: ele.code,
        name: ele.name,
        parent: ele.parent ? ele.parent : 0,
        // amount: children1.length > 0 ? (totalamountData < 0 ? (totalamountData * -1) : totalamountData) : this.roundOfDecimal(ele.amount < 0 ? ele.amount * -1 : ele.amount, 2),

        amount:
          children1.length > 0
            ? parseFloat(totalamountData)
            : parseFloat(ele.amount),
        children: children1,
        group_id: ele.group_id ? ele.group_id : 0,
        ...amount,
      };
      if (name !== "Income") {
        ele.amount = ele.amount * -1;
      }
      return ele;
    },
    sumTotal(arr, amount) {
      return arr
        .reduce((sum, item) => sum + parseFloat(item[amount] ?? 0), 0)
        .toFixed(2);
    },
    async incomeDataArr(res) {
      var totalamount = 0;
      let groups = (res.groups ? res.groups : []).concat(
        res.ledgers ? res.ledgers : []
      );

      groups.forEach((ele, index) => {
        let childrens = (ele.groups ? ele.groups : []).concat(
          ele.ledgers ? ele.ledgers : []
        );

        var amount = {
          totalamount: 0,
        };
        let children1 = [];

        childrens.map((item) => {
          let tempData = {};
          if (item.ledgers) {
            tempData = this.recorsionFun(item, "Income");
            item = tempData;
          } else {
            amount.totalamount += parseFloat(item.amount);
          }
          children1[index] = item;
        });
        totalamount += parseFloat(ele.amount);
        // childrens.push({
        //   name: `Total Income`,
        //   amount: ele.amount,
        //   id: `Total Income`,
        //   total: true,
        // });
        this.DetailedOpen = { ...this.DetailedOpen, [ele.id]: true };
        ele = {
          id: ele.id,
          code: ele.code,
          // total: ele.total,

          name: ele.name,
          parent: ele.parent ? ele.parent : 0,
          amount: parseFloat(ele.amount, 2),
          children: children1,

          group_id: ele.group_id ? ele.group_id : 0,
          ...amount,
        };
        groups[index] = ele;
      });
      this.incomeData = groups;
      this.incomeTemp = {
        name: "Income",
        data: this.incomeData,
        totalamount: totalamount,
      };
      this.incomeData = this.incomeTemp;
      this.expenseData.netProfit = parseFloat(
        totalamount - parseFloat(this.expenseData.totalamount ?? 0) - (this.cogsData.totalamount ?? 0)
      );

      this.$forceUpdate();
    },
    cogsDataArr(res) {
      var totalamount = 0;
      let groups = (res.groups ? res.groups : []).concat(
        res.ledgers ? res.ledgers : []
      );
      groups.forEach((ele, index) => {
        let childrens = (ele.groups ? ele.groups : []).concat(
          ele.ledgers ? ele.ledgers : []
        );
        // childrens.push({
        //   name: "Total Expense",
        //   amount: this.expense[0].amount,
        //   id: "Total Expense",
        //   total: true,
        // });
        var amount = {
          totalamount: 0,
        };
        let children1 = [];
        childrens.map((item) => {
          let tempData = {};
          tempData = this.recorsionFun(item, "Cogs");
          item = tempData;
          if (item.ledgers) {
          } else {
            amount.totalamount += parseFloat(item.amount, 2);
          }
          children1[index] = item;
        });
        totalamount += parseFloat(parseFloat(ele.amount * -1));
        this.DetailedOpen = { ...this.DetailedOpen, [ele.id]: true };
        let totalamountData;
        if (children1.length > 0) {
          totalamountData = this.sumTotal(children1, "amount");
        }
        ele = {
          id: ele.id,
          // total: ele.total,
          code: ele.code,
          name: ele.name,
          parent: ele.parent ? ele.parent : 0,
          amount:
            children1.length > 0
              ? parseFloat(totalamountData * -1)
              : parseFloat(ele.amount * -1),

          children: children1,
          group_id: ele.group_id ? ele.group_id : 0,
          ...amount,
        };

        groups[index] = ele;


      });
      this.cogsData = groups;
      this.cogsTemp = {
        name: "Cost of Goods Sold",
        data: this.cogsData,
        totalamount: totalamount,
      };
      this.cogsData = this.cogsTemp;
      this.expenseData.netProfit = parseFloat(
       (this.incomeData.totalamount ?? 0) - totalamount - parseFloat(this.expenseData.totalamount ?? 0)
      );
      this.$forceUpdate();
    },
    async searchData(tableData) {
      this.showHideData = {};
      this.expanded = {};
      this.ledgerExpanded = {};
      this.dataObj = {};
      const data = {
        startdate: this.startdate,
        enddate: this.enddate,
      };
      await axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify(data),
        url: `${this.baseApi}/profitloss`,
      }).then(async (response) => {
        this.income = response.data.data[0]
        this.cogs = response.data.data[1]
        this.expense = response.data.data[2]

        this.incomeDataArr(this.income);
        this.cogsDataArr(this.cogs);
        var totalamount = 0;
        let groups = (this.expense.groups ? this.expense.groups : []).concat(
          this.expense.ledgers ? this.expense.ledgers : []
          );
        groups.forEach((ele, index) => {
          let childrens = (ele.groups ? ele.groups : []).concat(
            ele.ledgers ? ele.ledgers : []
          );
          // childrens.push({
          //   name: "Total Expense",
          //   amount: this.expense[0].amount,
          //   id: "Total Expense",
          //   total: true,
          // });
          var amount = {
            totalamount: 0,
          };
          let children1 = [];
          childrens.map((item) => {
            let tempData = {};
            tempData = this.recorsionFun(item, "Expense");
            item = tempData;
            if (item.ledgers) {
            } else {
              amount.totalamount += parseFloat(item.amount, 2);
            }
            children1[index] = item;
          });
          totalamount += parseFloat(parseFloat(ele.amount * -1));
          this.DetailedOpen = { ...this.DetailedOpen, [ele.id]: true };
          let totalamountData;
          if (children1.length > 0) {
            totalamountData = this.sumTotal(children1, "amount");
          }
          ele = {
            id: ele.id,
            // total: ele.total,
            code: ele.code,
            name: ele.name,
            parent: ele.parent ? ele.parent : 0,
            amount:
              children1.length > 0
                ? parseFloat(totalamountData * -1)
                : parseFloat(ele.amount * -1),

            children: children1,
            group_id: ele.group_id ? ele.group_id : 0,
            ...amount,
          };

          groups[index] = ele;

        });
        this.expenseData = groups;
        this.expenseTemp = {
          name: "Expense",
          data: this.expenseData,
          totalamount: totalamount,
          netProfit: parseFloat(
            (this.incomeData.totalamount ?? 0) - parseFloat(totalamount) - (this.cogsData.totalamount ?? 0)
            ),
          };
        this.expenseData = this.expenseTemp;
          this.$forceUpdate();

        // this.expense.map((item) => {
        //   item.plus = false;
        //   if (item.groups.length > 0 || item.ledgers.length > 0) {
        //     item.plus = true;
        //   }
        //   this.expenseObj[item.id] = item;
        //   item.groups.map((innerItem) => {
        //     if (this.expenseObj[innerItem.id]) {
        //       delete this.expenseObj[innerItem.id];
        //     }
        //   });
        // });
        // this.expanse = [];
        // for (let key in this.expanseObj) {
        //   this.expanse.push(this.expanseObj[key]);
        // }

        // this.income.map((item) => {
        //   item.plus = false;
        //   if (item.groups.length > 0 || item.ledgers.length > 0) {
        //     item.plus = true;
        //   }
        //   this.incomeObj[item.id] = item;
        //   item.groups.map((innerItem) => {
        //     if (this.incomeObj[innerItem.id]) {
        //       delete this.incomeObj[innerItem.id];
        //     }
        //   });
        // });
        // this.income = [];
        // for (let key in this.incomeObj) {
        //   this.income.push(this.incomeObj[key]);
        // }

        // this.data = this.expense.concat(this.income);
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
